import { gql } from "@apollo/client";

export const RETAILERS_QUERY = gql`
  query Retailers {
        retailerList {
            items {
                channel
                coverage
                parentCompany
                retailerName
                routeToMarket
            }
        }

        retailerReportedDollarsSolds {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
         }

         retailerReportedUnitsSolds {
                items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
                }
            }
             retailerSalesGrowthRateDollarsSolds {
                items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
                }
            }
              retailerACVDollarsKPI {
                items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
                }
            }

        retailerDollarSoldPerAvgWeeklyTPDs {
                items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                    cqcYvsCQLY
                    cQvsGoal
                    cQvsLQ
                    currentMonth
                    currentQuarter
                    currentYear
                    cYvsGoal
                    cYvsLY
                    goalCurrentMonth
                    goalCurrentQuarter
                    goalCurrentYear
                    lastMonth
                    lastQuarter
                    lastYear
                    sameMonthLastYear
                    sameQuarterLastYear
                }
        }
            retailerUnitsSoldPerAvgWeeklyTPDs {
                items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
                }
            }
            retailerAveragePricePerUnits {
                items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
                }
            }
            retailerPctDollarsSoldOnPromotions {
                items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
                }
            }

             retailerPctDollarsSoldOnDisplays {
                items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
                }
            }



        retailerSubBrandByDollarsSales {
            items {
            lastPeriodNetSales
            name
            netSales
            percentage
            rank
            unitSold
            }
        }
        retailerSKUsByDollarsSales {
            items {
            lastPeriodNetSales
            name
            netSales
            percentage
            rank
            unitSold
            }
        }
        retailerDivisionByDollarsSales {
            items {
            lastPeriodNetSales
            name
            netSales
            percentage
            rank
            unitSold
            }
        }

        retailerReportedDollarsSoldBySubBrand {
            items {
                lastPeriodNetSales
                name
                netSales
                percentage
                rank
                unitSold
            }
        }


        brandMarketShareByDollarSold {
            items {
                brandName
                currentYear
                dollarSoldCurrentMonth
                dollarSoldCurrentQuarter
                dollarSoldLastMonth
                dollarSoldLastQuarter
                lastYear
                percentage
            }
        }



        retailerReportedDollarsSoldByRegion {
            items {
                lastPeriodNetSales
                name
                netSales
                percentage
                rank
                unitSold
            }
        }



        retailerReportedDollarsSoldByTop5Divisions {
            items {
                lastPeriodNetSales
                name
                netSales
                percentage
                rank
                unitSold
            }
        }


        retailerReportedDollarsSoldByState {
            items {
            mtdValue
            qtdValue
            stateName
            ytdValue
            }
        }


        retailerReportedDollarsSoldByRegionSubBrand {
            items {
                region
                value {
                brand
                value
                }
            }
        }


        retailerReportedDollarsSoldSubBrandMonthly {
            items {
                month
                values {
                percentage
                subBrandName
                value
                }
            }
        }


        retailerAllCommodityVolumeSubBrandMonthly {
            items {
                month
                value {
                subBrand
                value
                }
            }
        }
        retailerReportedDollarsBrandCompetitors {
            items {
            brandName
            currentMonth
            currentQtr
            currentYear
            lastMonth
            lastQtr
            lastYear
            }
        }


        retailerTop10OrderedSKUsByReportedDollarsSold {
            items {
            rank
            skuName
            value
            }
        }



        retailerBottom10OrderedSKUsByReportedDollarsSold {
            items {
            rank
            skuName
            value
            }
        }

        basePriceVsPromotedPrice {
            items {
                avgPromoPriceMTDCurrent
                avgPromoPriceMTDLast
                avgPromoPriceQTDCurrent
                avgPromoPriceQTDLast
                avgPromoPriceYTDCurrent
                avgPromoPriceYTDLast
                basePriceMTDCurrent
                basePriceMTDLast
                basePriceQTDCurrent
                basePriceQTDLast
                basePriceYTDCurrent
                basePriceYTDLast
                brandName
                categoryName
                channelName
                companyName
                routeToMarketName
                subBrandName
            }
        }

    }
`;

